import mockAxios, { AxiosResponse } from 'axios';
import { ISalesRepServiceMock } from './sales-rep.mock.types';

export const mockSalesRepService = (): ISalesRepServiceMock => ({
  fetchSalesReps: jest.fn(),
  fetchSalesRep: jest.fn()
});

export const mockSalesRepAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
